import { render } from "./ProductList.vue?vue&type=template&id=5d5f0c50&scoped=true"
import script from "./ProductList.vue?vue&type=script&lang=js"
export * from "./ProductList.vue?vue&type=script&lang=js"

import "./ProductList.vue?vue&type=style&index=0&id=5d5f0c50&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5d5f0c50"

export default script